import type { Observable } from 'rxjs';

import { useBackendHttpService } from '../../http';
import type { OrgUserDto, OrgUserPendingDto, OrganizationDto } from '../domain';

const API = '/s/organization/v1/organizations';

export function fetchOrganization(orgId: string): Observable<OrganizationDto> {
	const { http } = useBackendHttpService();
	return http.get(`${API}/${orgId}`);
}

export function fetchOrganizationUsers(orgId: string): Observable<OrgUserDto[]> {
	const { http } = useBackendHttpService();
	return http.get(`${API}/${orgId}/users`);
}

export function fetchOrganizationActiveUsers(orgId: string, yearMonth: string): Observable<OrgUserDto[]> {
	const { http } = useBackendHttpService();
	return http.get(`${API}/${orgId}/active-users`, { params: { yearMonth } });
}

export function fetchOrganizationPendingInvitations(orgId: string): Observable<OrgUserPendingDto[]> {
	const { http } = useBackendHttpService();
	return http.get(`${API}/${orgId}/invitations`);
}
